import { createElement } from 'react';
import { bD as __rest, bE as __assign } from './index.esm-47de5464.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var SvgComponent = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6413 13.343L12.0043 21.051L17.3603 13.352C18.1743 12.229 18.6043 10.896 18.6043 9.50002C18.6043 5.86002 15.6433 2.90002 12.0043 2.90002C8.3653 2.90002 5.4043 5.86002 5.4043 9.50002C5.4043 10.897 5.8343 12.229 6.6413 13.343ZM6.6043 9.50002C6.6043 6.52302 9.0263 4.10002 12.0043 4.10002C14.9823 4.10002 17.4033 6.52202 17.4033 9.50002C17.4033 10.641 17.0523 11.73 16.3813 12.657L12.0043 18.949L7.6203 12.648C6.9553 11.73 6.6043 10.642 6.6043 9.50002ZM9.44922 9.50001C9.44922 10.906 10.5932 12.05 11.9992 12.05C13.4052 12.05 14.5492 10.906 14.5492 9.50001C14.5492 8.09401 13.4052 6.95001 11.9992 6.95001C10.5932 6.95001 9.44922 8.09401 9.44922 9.50001ZM10.5492 9.50001C10.5492 8.70001 11.2002 8.05001 11.9992 8.05001C12.7982 8.05001 13.4492 8.70001 13.4492 9.50001C13.4492 10.3 12.7982 10.95 11.9992 10.95C11.2002 10.95 10.5492 10.3 10.5492 9.50001Z"
  }));
};

export default SvgComponent;
